import environment, { BarkioOnly, BibinoOnly } from "src/utils/environment";
import getImageSrc from "src/utils/getImageSrc";
import BabyLottieAnimation from "src/modules/avatar/components/BabyLottieAnimation";
import { Image } from "@chakra-ui/react";
import avatarFiles from "src/modules/avatar/avatar-files";
import { useMemo } from "react";

const { isBrowser } = environment;

export default function CorrespondingAvatar({
  width,
  height,
  customAvatar,
  avatar,
  ...rest
}) {
  const StyledImage = useMemo(
    () =>
      ({ ...rest }) =>
        (
          <Image
            width={width}
            height={height}
            borderRadius="100%"
            objectFit="cover"
            {...rest}
          />
        ),
    [width, height]
  );

  if (avatar?.profileImageFile) {
    return (
      <StyledImage
        {...rest}
        src={
          isBrowser
            ? avatar.profileImageFile.url
            : avatarFiles.getSrc(avatar.profileImageFile.name)
        }
      />
    );
  }
  if (customAvatar) {
    return <StyledImage {...rest} src={customAvatar} />;
  }
  return (
    <>
      <BibinoOnly
        width={width}
        height={height}
        sex={avatar?.sex}
        browserProps={{
          useTheme: false
        }}
        {...avatar?.avatarCustomization}
        skinColor={
          avatar?.avatarCustomization?.skinColor ||
          avatar?.moreDataJson?.skinColor
        }
        animationName="default-avatar.json"
        {...rest}
      >
        {BabyLottieAnimation}
      </BibinoOnly>
      <BarkioOnly
        src={getImageSrc(
          `${avatar?.avatarCustomization?.breedAppearance || "default"}.svg`,
          { directory: "dog-avatars" },
          { useTheme: false }
        )}
      >
        {StyledImage}
      </BarkioOnly>
    </>
  );
}
